<template>
	<div class="page-inicio">
		<template v-if="user">

			<!-- HEADER -->
			<header >
				<ul>
					<li>
						<div class="go-home">
							<i @click="minimizeAll()" class="el-icon-s-home"></i>
							<template v-if="menu && menu.length">
								<el-menu slot="dropdown" :collapse="true">
									<el-submenu index="1">
										<template slot="title">
											<i class="el-icon-arrow-down"></i>
										</template>
										<el-submenu v-for="(item,i) in menu" :key="i" :index="`1-${i}`">
											<span slot="title">{{item.name}}</span>
											<el-menu-item 
											v-for="(option,o) in item.options" 
											:key="o" 
											:index="`1-${i}-${o}`" 
											@click="nuevaVentana(option)">
												{{option.name}}
											</el-menu-item>
										</el-submenu>
									</el-submenu>
								</el-menu>
							</template>
						</div>
					</li>
					<li
						v-for="w of ventanas"
						:key="w.name"
						@click="clickWindow(w)"
						:class="[{open: w.isOpen}, {active: w.active}]">
						{{`${w.name} `}}
						<i class="el-icon-close" @click.stop.prevent="cerrar(w)"></i>
					</li>
				</ul>
				<MenuHeader @openWindow="nuevaVentana"/>
			</header>

			<!-- VENTANAS TIPO TABS (con iframe) -->
			<hsc-window-style-white>
				<hsc-window
					v-for="w of ventanas" 
					:key="w.name"
					:width="w.width"
					:height="w.height"
					:closeButton="false" 
					:isOpen.sync="w.isOpen"
					:left.sync="w.left"
					:top.sync="w.top"
					@activate="activate(w)"
					:class="[{active: w.active}]"
					:style="{'z-index': w.active ? 999 : 0}">

					<div ref="handle" class="window-nav"></div>
					
					<div class="window-inner">
						<iframe
						:src="w.url"
						width="100%"
						height="100%"
						frameborder="0" 
						style="border:0;" 
						allowfullscreen="" 
						aria-hidden="false" 
						tabindex="0"></iframe>
					</div>

				</hsc-window>
			</hsc-window-style-white>

			<!-- Ficha Dashboard || Home del usuario -->
			<div class="screen">
				<FichaEstructura
					:class="[{'window-active': ventanas.length}]"
					:entidad="user.entidad"
					@openWindow="nuevaVentana"
					:active="ventanas.every(e => !e.isOpen)"/>
			</div>

			<!-- VENTANAS TIPO WINDOW -->
			<!--<hsc-window-style-white>
				<hsc-window
					v-for="w of ventanas" 
					:key="w.id"
					:width="w.width"
					:height="w.height"
					:closeButton="false" 
					:isOpen.sync="w.isOpen"
					:left.sync="w.left"
					:top.sync="w.top"
					@activate="activate(w)"
					:class="[{active: w.active}]"
					:style="{'z-index': w.active ? 999 : 100}">

					<div
						ref="handle"
						class="window-nav"
						@mousedown="mousedown($event, w)"
					>
						<span>{{w.type == 'iframe' ? w.code : `${w.title} ${w.code}`}}</span>
						<div class="window-nav-action">
							<i v-if="w.type !== 'iframe'" class="el-icon-refresh" @click="update(w)" title="actualizar"></i>
							<i class="el-icon-minus" @click="minimizar(w)" title="minimizar"></i>
							<i class="el-icon-news" @click="maximizar(w)" title="maximizar"></i>
							<i class="el-icon-close" @click="cerrar(w)" title="cerrar"></i>
						</div>
					</div>
					
					<div class="window-inner">
						
						<iframe
							v-if="w.type == 'iframe'"
							title="Inline Frame Example"
							width="100%"
							height="100%"
							frameborder="0"
							:src="w.url">
						</iframe>
						<FichaEstructura
							v-else
							:id="w.code"
							:entidad="w.entidad"
							:active="w.active"
							@openWindow="nuevaVentana"
							/>
					</div>

				</hsc-window>
			</hsc-window-style-white>-->

			<!-- Barra de ventanas minimizadas -->
			<!--<div class="window-bar" v-if="ventanas.length">
				<ul>
					<li
						v-for="w of ventanas" 
						:key="w.id"
						@click="w.isOpen = !w.isOpen"
						:class="[{open: w.isOpen}, {active: w.active}]">
						{{`${w.title} ${w.code}`}}
					</li>
				</ul>
			</div>-->

		</template>
	</div>
</template>

<script>
	import FichaEstructura from '@/components/FichaEstructura.vue'
	import MenuHeader from '@/components/Porlet/PorletMenuHeader.vue'

	import { mapState } from 'vuex'

	export default {
		name: 'Inicio',
		components: {
			MenuHeader,
			FichaEstructura
		},
		data() {
			return {
				ventanas: []
			}
		},
		computed: {
			...mapState({
				user: state => state.user.data
			}),
			menu() {
				return JSON.parse(localStorage.getItem('menu')) || []
			}
		},
		watch: {
			user() {
				//this.init()
			}
		},
		created() {
			//this.init()
		},
		methods: {
			/*async init() {
				console.log('init inicio')
				let dashboard = []

				try {

					let {data} = await (await fetch(`/${window.distributionconfig.dashboard}.json`, {
						method: 'GET'
					})).json()

					dashboard = data

				} catch (err) {
					
					console.log(err)
				}

				if (this.user && this.user.dashboard) {

					dashboard = [...this.user.dashboard, ...dashboard]
					
				}
				
				this.dashboard = dashboard

				// Graficas
				this.initChartCircle()
				this.initChartBar()
				
			},*/
			
			// Abrir ventana
			nuevaVentana(action) {
				console.log('inicio -> nuevaVentana: ',action)

				// Comprobar que ya este abierta (id y entidad)
				const ventanaExist = this.ventanas.find(f => f.name == action.name)
				if (ventanaExist) {

					this.activate(ventanaExist)
					ventanaExist.isOpen = true
					
					return
				}
				
				// Comprobar limite de ventanas abietras
				if (this.ventanas.length >= 5) {
					this.$alert('Has llegado al limite de ventanas abiertas', 'Cierra alguna ventana', {
						confirmButtonText: 'Aceptar'
					})
					return
				}

				this.ventanas.push({
					isOpen: true,
					active: false,
					name: action.name,
					url: action.link.includes('http') ? action.link : `${location.origin}/#${action.link}`
				})
			},

			// Eventos de ventana
			clickWindow(w) {
				
				if (w.isOpen && !w.active) {
					w.active = true
				} else if (w.isOpen && w.active) {
					w.active = false
					w.isOpen = false

					this.minimizeAll()
					
					return


				} else if (!w.isOpen && !w.active) {
					w.active = true
					w.isOpen = true
				}

				this.ventanas.filter(f => f.name !== w.name).forEach(w => {
					w.active = false
				})
			},
			cerrar(w) {

				// Quitar ventana actual
				let ventanaIndex = this.ventanas.findIndex(f => f.name == w.name)
				this.ventanas.splice(ventanaIndex, 1)

				// Mostrar por defecto la primera ventana
				if (this.ventanas.length) {
					this.clickWindow(this.ventanas[0])
				}
				
			},
			activate(w) {
				this.ventanas.forEach(f => f.active = false)
				w.active = true
			},
			minimizeAll() {
				this.ventanas.forEach(w => {
					w.isOpen = false
					w.active = false
				})
			}
		}
	}
</script>

<style lang="scss">

@import '@/assets/scss/variables.scss';

.page-inicio {
	height: 100vh;

	.window {
		left: 0px !important;
		top: 40px !important;
		right: 0px !important;
		bottom: 0px !important;
		box-shadow: unset!important;
		background-color: white!important;
		border-radius: 0px;
		.titlebar  {
			display: none!important;
		}
		.content {
			padding: 0px!important;
			.window-inner {
				height: 99%!important;
			}
		}
	}

	// HEADER
	> header {
		background-color: $--color-main-header;
		display: flex;
    	justify-content: flex-end;
    	padding: 1px 15px;
		justify-content: space-between;

		ul {
			list-style: none;
			padding: 0px;
			margin: 0px;
			display: flex;
			align-items: center;

			li {
				padding: 5px 5px 4px 5px;
				font-size: 0.9rem;
				margin-right: 5px;
				cursor: pointer;
				-webkit-transition-duration: 200ms;
				transition-duration: 200ms;
				border-bottom: 2px solid #5f5f5f;
				color: #a2a2a2;
				margin-right: 25px;

				&:first-child {
					border: 0px;
					padding: 2px 5px 2px 5px;
				}

				&:hover {
					//background-color: #edeff3
					color: white;
				}
				
				&.open {
					//background-color: #4a596aab;
					//color: white;
					&.active {
    					border-color: white;
						color: white;
					}
				
					&:hover {
						//background-color: #414c59;
						color: white;
					}
				}

				.go-home {
					display: flex;
					align-items: center;
					border-radius: 25px;
					border: 1px solid grey;

					i {
						font-size: 0.9rem;
						border-radius: 50%;
						background-color: #ffffff;
						padding: 6px 6px;
						color: #656565;
						margin: 3px;
					}
					ul {
						width: auto!important;
						background-color: transparent;
						border: 0px;
						li {
							margin: 0px!important;
							padding: 0px!important;
							.el-submenu__title {
								height: auto;
    							line-height: initial;
								padding: 0px!important;
								background-color: unset!important;
								> i {
									font-size: 0.9rem !important;
									background-color: transparent;
									color: #ababab;
								}
								&:hover {
									> i {
										color: white;
									}
								}
							}
						}
					}
				}
			}
		}
	}

	.screen {
		height: calc(100% - 40px);
	}
}
</style>
